"use client"

const BlockchainSelector = ({
  selectBlockchain,
  setSelectBlockchain,
  blockChainSearchKeyword,
  setBlockChainSearchKeyword,
  staticBlockchains,
  selectBlockChain,
  blockChainSelectionContext,
  blockChainSellSelected,
  blockChainBuySelected,
}) => {
  if (!selectBlockchain) return null
  console.log(staticBlockchains)
  return (
    <div className={`rango-select-widget ${selectBlockchain ? "show" : ""}`}>
      <div className="rango-selected-widget">
        <div className="rango-flex rango-flex--between">
          <div className="rango-icon" onClick={() => setSelectBlockchain(false)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m12 19l-7-7l7-7m7 7H5"
              />
            </svg>
          </div>
          <div className="rango-title">Select Blockchain</div>
          <div />
        </div>
        <div className="rango-input--icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
              <path d="m21 21l-4.34-4.34" />
              <circle cx="11" cy="11" r="8" />
            </g>
          </svg>
          <input
            onChange={(event) => setBlockChainSearchKeyword(event.target.value.trim())}
            type="text"
            className="rango-select--item"
            placeholder="Search blockchains by name"
          />
        </div>
        <div className="rango-connect--options">
          {staticBlockchains
            .filter((el) => {
              if (blockChainSearchKeyword === "") return true
              return el.displayName.toUpperCase().startsWith(blockChainSearchKeyword.toUpperCase())
            })
            .map((blockchain, index) => (
              <button
                key={index}
                onClick={() => selectBlockChain(blockchain)}
                className={`rango-option--item ${blockchain.name === (blockChainSelectionContext === "sell" ? blockChainSellSelected.name : blockChainBuySelected.name) ? "active" : ""}`}
              >
                <img alt={blockchain.name} src={blockchain.image || "/placeholder.svg"} />
                <div className="text">{blockchain.name}</div>
              </button>
            ))}
        </div>
      </div>
    </div>
  )
}

export default BlockchainSelector
